import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box, FormControlLabel, TextField, } from '@mui/material';
const FillInTheBank = ({ response, setResponse, disabled, }) => (_jsx(Box, { sx: { ml: '5%' }, children: _jsx(FormControlLabel, { sx: {
            width: '80%',
            mt: 4,
        }, name: "fillInTheBlank", label: " ", labelPlacement: "end", "aria-labelledby": "label-fillInTheBlank", control: (_jsx(TextField, { sx: {
                width: '80%',
                color: 'contract.main',
            }, name: "fillInTheBlank", value: response, onChange: (ev) => setResponse(ev.target.value), disabled: disabled })) }) }));
export default observer(FillInTheBank);
//# sourceMappingURL=FillInTheBlank.js.map